import React from 'react'
import './bud.css'
import axios from "axios";
import Forecast from './BudgetComponants/Forcast';

function Home() {

//     const options = {
//         method: 'GET',
//         url: 'https://shaisachs-mortgage-payments-v1.p.rapidapi.com/payments',
//         params: {price: '300000', downPayment: '10000', interestRate: '0.0175'},
//         headers: {
//           'x-rapidapi-key': 'e316d60d8emsh28b8363aea078b3p13ccb0jsna71486b41a20',
//           'x-rapidapi-host': 'shaisachs-mortgage-payments-v1.p.rapidapi.com'
//         }
//       };

// let price = 'ok';
// if (options.params.price){
//     price = options.params.price;
// }


 
//       axios.request(options).then(function (response) {
//         console.log(response.data);
//     }).catch(function (error) {
//         console.error(error);
//     });

    return (
        <div>


            


            {/* old code below */}
            {/* <p>{price}</p> */}
           <form>
      <label>User Name</label>
      <br/>
      <input type="input" className="home"/>
<br/>
      <label>Chequing Account</label>
      <br/>
      <input type="input" className="home"/> 
<br/>
      <label>Savings Account</label>
      <br/>
      <input type="input" className="home"/>
      </form>
      <br/>
      <br/>
      <button className="Button2"><a href="https://www.td.com/ca/en/personal-banking/products/mortgages/calculators-tools/?GOOGLE&Mortgage+Calculator+-+Generic+-+English+(21_S_RL_RMO_AO_ACQ_ENFR)&Calculator+-+Generic+-+Exact&gclid=Cj0KCQiAj9iBBhCJARIsAE9qRtCFflyczKStvNzEG1tYwXzEYYaoUPmGL2YNVE5jM3FPPuhHhaAssIYaAnvVEALw_wcB&gclsrc=aw.ds">TD Mortgage Calculator</a></button>
      
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
      <br/>
     
      

      
            <main>
                <Forecast/>
            </main>
            

        </div>
    )
}

export default Home